import { DynamicComponentInjectorService } from './dynamic-component-injector.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicContainerDirective } from './dynamic-container.directive';
import { DynamicContainerComponent } from './dynamic-container/dynamic-container.component';

@NgModule({
    declarations: [DynamicContainerDirective, DynamicContainerComponent,],
    providers: [DynamicComponentInjectorService],
    imports: [CommonModule],
    exports: [DynamicContainerDirective, DynamicContainerComponent,],
})
export class DynamicComponentInjectorModule {}
